import { fmt } from 'components/IntlWrapper/IntlWrapper';

export const KEYBOARD = {
  ESCAPE: 'Escape'
};

export const KEYBOARD_KEY_CODE = {
  ESCAPE: 27,
  ENTER: 13,
  BACKSPACE: 8
};

export const EVENTS = {
  KEYDOWN: 'keydown',
  CLICK: 'click'
};

export const UPLOADED_FILE_TYPES = {
  JPG: 'image/jpeg',
  PNG: 'image/png',
  GIF: 'image/gif',
  XLSX: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  CSV: 'text/csv'
};

export const FEATURES_CONFIGURATIONS_KEYS = {
  HIDE_ENABLE_sLLR_PAY_BANNER: 'hideEnableSllrPayBanner',
  SELECT_FROM_PRODUCTS: 'selectFromProducts'
};

export const AVAILABILITY = {
  DROPOFF: 'dropOffAvailability',
  PICKUP: 'pickupAvailability'
};

export const CONTEXT = {
  dropOffAvailability: 'dropoff',
  pickupAvailability: 'pickup'
};

export const OPEN_PACKAGE_FEES_AVAILABILTY = {
  EG: true,
  SA: false
};

export const APP_NAME = 'SLLR';

export const UNAUTHORIZED_ERROR_MSG = fmt({
  id: 'team_members.unauthorized_error_msg'
});

export const SELECT_DATE = 'Select Date';
